"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDisabledArrow = exports.getNewDatesFromUpdateStartDate = exports.getNewDatesFromUpdateEndDate = exports.animateDateChange = exports.getNextDate = exports.getMonthDiffBetweenStartEnd = exports.getNextDayFromArray = exports.getNextValidDate = exports.getNextStepIndex = exports.getDefaultDates = exports.getFormatDateByDateType = exports.getPlaceholderByDateType = void 0;
const luxon_1 = require("luxon");
const constants_1 = require("./constants");
const getPlaceholderByDateType = (dateType) => constants_1.DatesPlaceholder[dateType];
exports.getPlaceholderByDateType = getPlaceholderByDateType;
const getFormatDateByDateType = (dateType) => constants_1.DatesFormat[dateType];
exports.getFormatDateByDateType = getFormatDateByDateType;
const getDefaultDates = (dates, minDate, dayChangeStep, minMonthDiffNumber) => {
    if (!(dates === null || dates === void 0 ? void 0 : dates[0]) || !(dates === null || dates === void 0 ? void 0 : dates[1])) {
        let startDate = minDate && luxon_1.DateTime.now() < luxon_1.DateTime.fromJSDate(minDate)
            ? luxon_1.DateTime.fromJSDate(minDate)
            : luxon_1.DateTime.now();
        let endDate = startDate;
        if (!(dates === null || dates === void 0 ? void 0 : dates[0])) {
            if (typeof dayChangeStep === "object") {
                startDate = startDate.set({ day: dayChangeStep[0] });
            }
        }
        if (!(dates === null || dates === void 0 ? void 0 : dates[1])) {
            if (minMonthDiffNumber) {
                endDate = endDate.plus({ month: minMonthDiffNumber });
            }
            else if (typeof dayChangeStep === "object") {
                endDate = endDate.set({ day: dayChangeStep[0] });
            }
            else if (typeof dayChangeStep === "number") {
                endDate = endDate.plus({ day: dayChangeStep });
            }
        }
        return [startDate.toJSDate(), endDate.toJSDate()];
    }
    return [dates[0], dates[1]];
};
exports.getDefaultDates = getDefaultDates;
const getNextStepIndex = (direction, currIndex, maxStepIndex) => {
    if (direction === "up") {
        return currIndex + 1 > maxStepIndex - 1 ? 0 : currIndex + 1;
    }
    return currIndex - 1 < 0 ? maxStepIndex - 1 : currIndex - 1;
};
exports.getNextStepIndex = getNextStepIndex;
const getNextValidDate = (newDate, direction, monthsToExclude) => {
    if (monthsToExclude.includes(newDate.month)) {
        return (0, exports.getNextValidDate)(newDate.plus({ month: direction === "up" ? 1 : -1 }), direction, monthsToExclude);
    }
    return newDate;
};
exports.getNextValidDate = getNextValidDate;
const getCurrentDateIndex = (date, datesStep) => {
    return datesStep.findIndex((step) => step === parseInt(luxon_1.DateTime.fromJSDate(date).toFormat("d"), 10));
};
const getNextDayFromArray = (date, datesStep, direction) => {
    const currStepIndex = getCurrentDateIndex(date, datesStep);
    const nextStepIndex = (0, exports.getNextStepIndex)(direction, currStepIndex, datesStep.length);
    return datesStep[nextStepIndex];
};
exports.getNextDayFromArray = getNextDayFromArray;
const getMonthDiffBetweenStartEnd = (date, datesStep, direction) => {
    const currStepIndex = getCurrentDateIndex(date, datesStep);
    const nextStepIndex = (0, exports.getNextStepIndex)(direction, currStepIndex, datesStep.length);
    if (direction === "up" && datesStep[nextStepIndex] < datesStep[currStepIndex]) {
        return 1;
    }
    if (direction === "down" && datesStep[nextStepIndex] > datesStep[currStepIndex]) {
        return -1;
    }
    return 0;
};
exports.getMonthDiffBetweenStartEnd = getMonthDiffBetweenStartEnd;
const getNextDate = (date, direction, type, datesStep, monthsToExclude) => {
    let newDate = luxon_1.DateTime.fromJSDate(date);
    if (type === "year") {
        return newDate.plus({
            [type]: direction === "up" ? 1 : -1,
        });
    }
    if (typeof datesStep === "number") {
        newDate = newDate.plus({
            days: direction === "up" ? datesStep : -datesStep,
        });
        if (monthsToExclude === null || monthsToExclude === void 0 ? void 0 : monthsToExclude.length) {
            newDate = (0, exports.getNextValidDate)(newDate, direction, monthsToExclude);
        }
        return newDate;
    }
    const nextDayFromArray = (0, exports.getNextDayFromArray)(date, datesStep, direction);
    newDate = newDate.set({
        day: nextDayFromArray,
    });
    const needUpdateMonth = (0, exports.getMonthDiffBetweenStartEnd)(date, datesStep, direction);
    if (needUpdateMonth) {
        newDate = newDate.plus({ month: needUpdateMonth });
    }
    if (monthsToExclude === null || monthsToExclude === void 0 ? void 0 : monthsToExclude.length) {
        newDate = (0, exports.getNextValidDate)(newDate, direction, monthsToExclude);
    }
    return newDate;
};
exports.getNextDate = getNextDate;
const getPartialDateChanged = (currentDate, newDate) => {
    const dateParts = ["day"];
    if (currentDate.year !== newDate.year) {
        dateParts.push("year");
    }
    if (currentDate.month !== newDate.month) {
        dateParts.push("month");
    }
    return dateParts;
};
const animateDateChange = (type, newDate, currentDate, element, setCurrentValue) => {
    const keyFramesIn = [
        { transform: "translateY(0)", opacity: 1 },
        {
            opacity: 0,
            offset: 0.6,
        },
        {
            transform: `translateY(${newDate > currentDate ? "-" : ""}45px)`,
        },
    ];
    const keyFramesOut = [
        {
            transform: `translateY(${newDate > currentDate ? "" : "-"}45px)`,
            opacity: 0,
        },
        {
            opacity: 0,
            offset: 0.6,
        },
        { transform: "translateY(0)" },
    ];
    const partialDateChanged = getPartialDateChanged(currentDate, newDate);
    const firstRollAnimation = element.animate(keyFramesIn, { duration: 300 });
    firstRollAnimation.finished.then(() => {
        if (partialDateChanged.includes(type)) {
            setCurrentValue(newDate.toFormat((0, exports.getFormatDateByDateType)(type)));
        }
        element.animate(keyFramesOut, { duration: 300 });
    });
};
exports.animateDateChange = animateDateChange;
const getNewDatesFromUpdateEndDate = (oldDates, newEndDate, direction, minMonthDiffNumber) => {
    const newStartDate = luxon_1.DateTime.fromJSDate(oldDates[0]);
    if (direction === "down") {
        if (minMonthDiffNumber) {
            const diffDatesBetweenStartEnd = newEndDate.diff(newStartDate, "months").get("months");
            if (diffDatesBetweenStartEnd < minMonthDiffNumber) {
                return [newEndDate.minus({ months: minMonthDiffNumber }).toJSDate(), newEndDate.toJSDate()];
            }
        }
        if (newStartDate > newEndDate) {
            return [newEndDate.minus({ day: 1 }).toJSDate(), newEndDate.toJSDate()];
        }
    }
    return [newStartDate.toJSDate(), newEndDate.toJSDate()];
};
exports.getNewDatesFromUpdateEndDate = getNewDatesFromUpdateEndDate;
const getNewDatesFromUpdateStartDate = (oldDates, newStartDate, direction, minMonthDiffNumber) => {
    const newEndDate = luxon_1.DateTime.fromJSDate(oldDates[1]);
    if (direction === "up") {
        if (minMonthDiffNumber) {
            const diffDatesBetweenStartEnd = newEndDate.diff(newStartDate, "months").get("months");
            if (diffDatesBetweenStartEnd < minMonthDiffNumber) {
                return [
                    newStartDate.toJSDate(),
                    newStartDate.plus({ months: minMonthDiffNumber }).toJSDate(),
                ];
            }
        }
        if (newStartDate > newEndDate) {
            return [newStartDate.toJSDate(), newStartDate.plus({ day: 1 }).toJSDate()];
        }
    }
    return [newStartDate.toJSDate(), newEndDate.toJSDate()];
};
exports.getNewDatesFromUpdateStartDate = getNewDatesFromUpdateStartDate;
const resetTimeFromDate = (date) => {
    return date.set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
};
const getDisabledArrow = (newDates, minDate, minMonthDiffNumber, dayChangeStep) => {
    const newStartDate = luxon_1.DateTime.fromJSDate(newDates[0]);
    const newEndDate = luxon_1.DateTime.fromJSDate(newDates[1]);
    const minDateToDateTime = luxon_1.DateTime.fromJSDate(minDate);
    const start = {
        day: [],
        month: [],
        year: [],
    };
    const end = {
        day: [],
        month: [],
        year: [],
    };
    if (resetTimeFromDate(newStartDate.minus({ year: 1 })) < resetTimeFromDate(minDateToDateTime)) {
        start.year = ["down"];
    }
    if (resetTimeFromDate(newEndDate.minus({ year: 1 })) < resetTimeFromDate(minDateToDateTime)) {
        end.year = ["down"];
    }
    if (minMonthDiffNumber &&
        newEndDate.minus({
            month: minMonthDiffNumber,
            day: typeof dayChangeStep === "number" ? dayChangeStep : 1,
        }) < minDateToDateTime) {
        end.month = ["down"];
    }
    if (typeof dayChangeStep === "number") {
        if (newEndDate.minus({ day: dayChangeStep }) < minDateToDateTime) {
            end.month = ["down"];
        }
        if (resetTimeFromDate(newStartDate.minus({ day: dayChangeStep })) <
            resetTimeFromDate(minDateToDateTime)) {
            start.month = ["down"];
        }
    }
    else if (dayChangeStep) {
        const currStepStartIndex = dayChangeStep.findIndex((step) => step === parseInt(newStartDate.toFormat("d"), 10));
        const currStepEndIndex = dayChangeStep.findIndex((step) => step === parseInt(newEndDate.toFormat("d"), 10));
        const nextStepStartIndex = (0, exports.getNextStepIndex)("down", currStepStartIndex, dayChangeStep.length);
        const nextStepEndIndex = (0, exports.getNextStepIndex)("down", currStepEndIndex, dayChangeStep.length);
        let newStepStartDate = newStartDate.set({ day: dayChangeStep[nextStepStartIndex] });
        let newStepEndDate = newEndDate.set({ day: dayChangeStep[nextStepEndIndex] });
        if (dayChangeStep[nextStepStartIndex] > dayChangeStep[currStepStartIndex]) {
            newStepStartDate = newStepStartDate.minus({ month: 1 });
        }
        if (dayChangeStep[nextStepEndIndex] > dayChangeStep[currStepEndIndex]) {
            newStepEndDate = newStepEndDate.minus({ month: 1 });
        }
        if (newStepStartDate < minDateToDateTime) {
            start.month = ["down"];
        }
        if (newStepEndDate < minDateToDateTime) {
            end.month = ["down"];
        }
    }
    return [start, end];
};
exports.getDisabledArrow = getDisabledArrow;
